import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useLiveQuery } from "dexie-react-hooks";
import { useSettings } from "../../contexts/SettingsContext";
import { db, Product } from "../../database/db";

export default function ProductSalesTab() {
  const { settings } = useSettings();

  const productSales = useLiveQuery(async () => {
    const sales = await db.sales.toArray();
    const products = await db.products.toArray();

    const salesByProduct = new Map();

    sales.forEach((sale) => {
      const parsedProducts = JSON.parse(sale.products);
      parsedProducts.forEach(
        (item: { product: Product; quantity: number; priceAtTime: number }) => {
          const current = salesByProduct.get(item.product.sku) || {
            quantity: 0,
            revenue: 0,
          };
          current.quantity += item.quantity;
          current.revenue += item.priceAtTime * item.quantity;
          salesByProduct.set(item.product.sku, current);
        }
      );
    });

    return products.map((product) => ({
      ...product,
      salesCount: salesByProduct.get(product.sku)?.quantity || 0,
      estimatedRevenue: salesByProduct.get(product.sku)?.revenue || 0,
    }));
  });
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Product Name</TableCell>
            <TableCell>SKU</TableCell>
            <TableCell align="right">Unit Price</TableCell>
            <TableCell align="right">Total Sales</TableCell>
            <TableCell align="right">Estimated Revenue</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {productSales?.map((product) => (
            <TableRow key={product.id}>
              <TableCell>{product.name}</TableCell>
              <TableCell>{product.sku}</TableCell>
              <TableCell align="right">
                {settings.currencySymbol}
                {product.price.toFixed(settings.currencyRounding)}
              </TableCell>
              <TableCell align="right">{product.salesCount}</TableCell>
              <TableCell align="right">
                {settings.currencySymbol}
                {product.estimatedRevenue.toFixed(settings.currencyRounding)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
